import { isAdminPath } from './isPath';

// employee's roles with access to the admin portal
const adminAccess = ['admin', 'service', 'accounting', 'finance', 'sales', 'tech', 'europe'];

export const hasAdminAccess = user => (user ? adminAccess.includes(user.role) : false);

export const isAdmin = user => (user ? user.role === 'admin' : false);

export const authUser = (state, path) => {
  const user = state.auth.user;
  const impersonatedUser = state.auth.impersonatedUser;

  const isEmployee = hasAdminAccess(user);
  const onAdminPath = isAdminPath(path);

  if (isEmployee && !onAdminPath && impersonatedUser) return impersonatedUser;
  return user;
};
